import { Injectable } from '@angular/core'
import { Observable, Subject } from 'rxjs'
import { KakaoShareData } from 'src/app/interfaces/kakao'
import { ShareOptions } from 'src/app/interfaces/main'
import { RouterService } from '../router/router.service'
import { LogService } from './../log/log.service'

export type WebviewPostParams = {
  name: MessageName
  params?: Record<string, any>
}

export enum MessageName {
  INIT = 'init',
  LEAVE = 'leave',
  COPY = 'copy',
  KAKAO_SHARE = 'kakaoShare',
  WEB_SHARE = 'webShare',
  HARDWARE_BACK_PRESS = 'hardwareBackPress',
  THINKING_CHAIR_CREATED = 'thinkingChairCreated',
}

@Injectable({
  providedIn: 'root',
})
export class WebviewService {
  constructor(private logService: LogService, private routerService: RouterService) {}

  private isFromWebView = false
  private initParams: any
  private initParamSubject = new Subject<any>()

  getInitParamSubject(): Observable<any> {
    return this.initParamSubject.asObservable()
  }

  get isWebView(): boolean {
    return this.isFromWebView
  }

  get initParam(): any {
    return this.initParams
  }

  set isWebView(value: boolean) {
    this.logService.setSuperProperty('isWebView', `${value}`)
    this.isFromWebView = value
  }

  init(): void {
    // only for ios
    window.addEventListener('message', (event) => {
      if (event.data && typeof event.data === 'string' && /^{.*}$/.test(event.data)) {
        try {
          const data = JSON.parse(event.data)
          this.handleInitMessage(data)
          this.handleBackPressMessage(data)
        } catch (error) {
          console.error(error)
        }
      }
    })
    // only for android
    document.addEventListener('message', (event: any) => {
      if (event.data && typeof event.data === 'string' && /^{.*}$/.test(event.data)) {
        try {
          const data = JSON.parse(event.data)
          this.handleInitMessage(data)
          this.handleBackPressMessage(data)
        } catch (error) {
          console.error('[Webview message parse error]: ' + event.data)
        }
      }
    })
  }

  postMessage(params: WebviewPostParams): void {
    if ((window as any).ReactNativeWebView) {
      ;(window as any).ReactNativeWebView.postMessage(JSON.stringify(params))
    }
  }

  /** webview 종료시 보낼 메세지 */
  postCloseMessage(): void {
    this.postMessage({ name: MessageName.LEAVE })
  }

  /** 뭔가 복사 했을 때 보낼 메세지 */
  postCopyClickedMessage(text: string): void {
    this.postMessage({ name: MessageName.COPY, params: { text } })
  }

  /** 카카오 공유시 보낼 메세지 */
  postKakaoShareMessage(params: KakaoShareData): void {
    this.postMessage({ name: MessageName.KAKAO_SHARE, params })
  }

  /** 웹쉐어 공유시 보낼 메세지 */
  postWebShareMessage(params: ShareOptions): void {
    this.postMessage({ name: MessageName.WEB_SHARE, params })
  }

  private handleInitMessage({ name, params }: WebviewPostParams): void {
    if (name === MessageName.INIT) {
      this.isWebView = true
    }

    if (params) {
      this.initParams = params
      this.initParamSubject.next(params)
    }
  }

  private handleBackPressMessage({ name }: WebviewPostParams): void {
    if (name === MessageName.HARDWARE_BACK_PRESS) {
      this.routerService.navigateBack()
    }
  }
}
